"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shared_1 = require("./shared");
const browser_1 = require("lepont/browser");
async function share(options) {
    await browser_1.sendMessage({
        type: shared_1.MSG_TYPE_SHARE,
        payload: options,
    });
}
exports.share = share;
